import React from 'react';
import SEO from './SEO';
import ContactForm from './forms/ContactForm';

const ContactUs = () => {
  return (
    <div className="contact-us">
      <SEO
        title="Contact Us - Lloyd James Media"
        description="Get in touch with Lloyd James Media for expert data consultancy services. Contact our team for personalized data solutions and business insights."
        keywords="contact Lloyd James, data consultancy contact, get in touch, business data services, Lloyd James contact"
        ogUrl={`${import.meta.env.VITE_SITE_URL || 'https://www.lloydjames.com'}/contact`}
      />
      <section
        className="h-[35vh] sm:h-[42vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/home-banner-1.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
        />
        
        {/* Hero Content */}
        <div className="relative z-10 flex items-center h-full px-3 sm:px-8 md:px-16 lg:px-24">
          <div className="text-left text-white max-w-2xl ml-0 sm:ml-8 md:ml-24 lg:ml-48 xl:ml-72">
            <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-3 sm:mb-6 leading-tight">
              We would love<br />
              <span className="font-bold" style={{ color: '#db0058' }}>to hear from you.</span>
            </h1>
            <p className="text-sm sm:text-lg md:text-xl mb-4 sm:mb-8 leading-relaxed">
              Fill in the below short form and we will call you right back.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="pt-6 pb-12 px-0 sm:pt-8 sm:pb-16 sm:px-4 md:px-8 lg:px-12 mb-0" style={{ backgroundColor: '#3a3a3a' }}>
        <div className="max-w-6xl mx-auto px-2 sm:px-4 md:px-8 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-6 gap-4 sm:gap-8">
            {/* Left Column - Contact Form */}
            <div className="lg:col-span-4">
              <ContactForm
                title="Get in touch!"
                webFormId="lloyd_james_contact_us_form"
                includeSubject={true}
                className="space-y-2 sm:space-y-3"
              />
            </div>

            {/* Right Column - Office Hours */}
            <div className="lg:col-span-2 p-3 sm:p-4 rounded-lg text-white" style={{ backgroundColor: '#ac1640' }}>
              <h3 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">Office Hours</h3>
              
              <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                <p className="text-base sm:text-lg">Mon - Fri: 9am - 5:30pm</p>
                <p className="text-base sm:text-lg">Sat & Sun: Closed</p>
              </div>
              
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="text-white">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <span className="text-sm sm:text-lg">sales@lloydjames.com</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="text-white">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <span className="text-sm sm:text-lg">0800 288 9949</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;